const Promotion = () => import('@/views/main/analysis/promotion/Promotion.vue')
export default {
  path: '/main/analysis/promotion',
  name: 'Promotion',
  component: Promotion,
  children: []
}
